export const CHAT_HISTORY_RENDER_LIMIT = 200;
